// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .addnews label{
 font-weight: bold;
}
.addnews input:focus{
    box-shadow: none;
}
.addnews select:focus{
    box-shadow: none;
} */
.form-group label {
  font-weight: bold;
}
.form-group input:focus {
  box-shadow: none;
}
.form-group select:focus {
  box-shadow: none;
}
.card-header {
  color: #7386d5;
  font-size: 1.5rem !important;
  font-weight: bold !important;
}
.card {
  width: 100%;
}
.form-group input {
  width: 350px;
}
.addnews-container form {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}
.add-img input {
  width: 270px !important;
}
.ck-editor-container {
  width: 100%;
  max-width: 100% !important;
}
.req-feild {
  color: red;
}
.news-description {
  max-width: 280px !important;
}
.news-items {
  min-width: -moz-fit-content !important;
  min-width: fit-content !important;
  max-width: 150px !important;
}
.filter-container {
  padding: 20px;
  display: flex;
  gap: 20px;
}
.filter-container .form-group select {
  max-width: max-content !important;
  font-weight: 700;
}
.ck-content {
  max-height: 500px !important;
  /* height: 400px !important; */
  border: 1px solid cornflowerblue !important;
}
.news-img-container {
  display: contents;
}
/* .table tbody th{
    min-width: fit-content;
} */
.draft-btn button {
  float: right;
  /* margin-right: 10%; */
  outline: none;
  border: none;
  padding: 7px;
  font-weight: 600;
  background: cornflowerblue;
}

.iframely-embed {
  height: 560px;
  max-height: 600px;
}
.iframely-embed .iframely-responsive {
  height: 560px;
  max-height: 600px;
}
.iframely-embed iframe {
  height: 100%;
}

.toggle-container {
  display: inline-block;
  position: relative;
}

.toggle-checkbox {
  display: none;
}

.toggle-label {
  display: block;
  width: 60px; /* Adjust width as needed */
  height: 30px; /* Adjust height as needed */
  background-color: black;
  border-radius: 3px; /* Half of height for a rounded appearance */
  position: relative;
  cursor: pointer;
}

.toggle-text {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px; /* Adjust left padding as needed */
  color: #fff;
  font-size: smaller;
  min-width: max-content;
}

.toggle-checkbox:checked + .toggle-label {
  background-color: #4caf50; /* Green color when toggle is ON */
}

.toggle-checkbox:checked + .toggle-label .toggle-text {
  left: 50%; /* Move text to the right when toggle is ON */
  transform: translateY(-50%) translateX(-50%);
}
`, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/news/news.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG;AACH;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,sCAAiC;EAAjC,iCAAiC;EACjC,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,aAAa;EACb,SAAS;AACX;AACA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,2CAA2C;AAC7C;AACA;EACE,iBAAiB;AACnB;AACA;;GAEG;AACH;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW,EAAE,2BAA2B;EACxC,YAAY,EAAE,4BAA4B;EAC1C,uBAAuB;EACvB,kBAAkB,EAAE,4CAA4C;EAChE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU,EAAE,kCAAkC;EAC9C,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA;EACE,SAAS,EAAE,6CAA6C;EACxD,4CAA4C;AAC9C","sourcesContent":["/* .addnews label{\n font-weight: bold;\n}\n.addnews input:focus{\n    box-shadow: none;\n}\n.addnews select:focus{\n    box-shadow: none;\n} */\n.form-group label {\n  font-weight: bold;\n}\n.form-group input:focus {\n  box-shadow: none;\n}\n.form-group select:focus {\n  box-shadow: none;\n}\n.card-header {\n  color: #7386d5;\n  font-size: 1.5rem !important;\n  font-weight: bold !important;\n}\n.card {\n  width: 100%;\n}\n.form-group input {\n  width: 350px;\n}\n.addnews-container form {\n  display: flex;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n.add-img input {\n  width: 270px !important;\n}\n.ck-editor-container {\n  width: 100%;\n  max-width: 100% !important;\n}\n.req-feild {\n  color: red;\n}\n.news-description {\n  max-width: 280px !important;\n}\n.news-items {\n  min-width: fit-content !important;\n  max-width: 150px !important;\n}\n.filter-container {\n  padding: 20px;\n  display: flex;\n  gap: 20px;\n}\n.filter-container .form-group select {\n  max-width: max-content !important;\n  font-weight: 700;\n}\n.ck-content {\n  max-height: 500px !important;\n  /* height: 400px !important; */\n  border: 1px solid cornflowerblue !important;\n}\n.news-img-container {\n  display: contents;\n}\n/* .table tbody th{\n    min-width: fit-content;\n} */\n.draft-btn button {\n  float: right;\n  /* margin-right: 10%; */\n  outline: none;\n  border: none;\n  padding: 7px;\n  font-weight: 600;\n  background: cornflowerblue;\n}\n\n.iframely-embed {\n  height: 560px;\n  max-height: 600px;\n}\n.iframely-embed .iframely-responsive {\n  height: 560px;\n  max-height: 600px;\n}\n.iframely-embed iframe {\n  height: 100%;\n}\n\n.toggle-container {\n  display: inline-block;\n  position: relative;\n}\n\n.toggle-checkbox {\n  display: none;\n}\n\n.toggle-label {\n  display: block;\n  width: 60px; /* Adjust width as needed */\n  height: 30px; /* Adjust height as needed */\n  background-color: black;\n  border-radius: 3px; /* Half of height for a rounded appearance */\n  position: relative;\n  cursor: pointer;\n}\n\n.toggle-text {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 10px; /* Adjust left padding as needed */\n  color: #fff;\n  font-size: smaller;\n  min-width: max-content;\n}\n\n.toggle-checkbox:checked + .toggle-label {\n  background-color: #4caf50; /* Green color when toggle is ON */\n}\n\n.toggle-checkbox:checked + .toggle-label .toggle-text {\n  left: 50%; /* Move text to the right when toggle is ON */\n  transform: translateY(-50%) translateX(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
